import React from "react";
import { Grid, Checkbox, FormControlLabel } from "@mui/material";

const QTDetailsCheckboxWithLabelSection = ({
  label,
  checked,
  onChange,
  disabled,
}) => {
  return (
    <Grid container alignItems={"center"} style={{ marginBottom: 24 }}>
      <span style={titleTextStyle}>{label}</span>
      <div style={{ width: "70%" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={onChange}
              disabled={disabled}
              sx={{
                color: "#515563",
                "&.Mui-checked": {
                  color: "#1976d2",
                },
                "&.Mui-disabled": {
                  color: "#515563",
                },
              }}
            />
          }
          label=""
          sx={{
            margin: 0,
            "& .MuiFormControlLabel-label": {
              fontSize: 14,
              fontWeight: 500,
              fontFamily: "Avenir Book, sans-serif",
              color: "#515563",
            },
          }}
        />
      </div>
    </Grid>
  );
};

export default QTDetailsCheckboxWithLabelSection;

const titleTextStyle = {
  width: "25%",
  color: "#020303",
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
};
